import React, { useState } from "react";
import solaceUno from "../../../assets/images/portfolio/solaceUno.JPG";
import amazonReplica from "../../../assets/images/portfolio/amazonReplica.JPG";
import startNukari from "../../../assets/images/portfolio/startNukari.JPG";
import marhaba from "../../../assets/images/portfolio/marhaba.JPG";
import oxyzn from "../../../assets/images/portfolio/oxyzn.JPG";
import bussinessMart from "../../../assets/images/portfolio/bussinessMart.JPG";
import pbmc from "../../../assets/images/portfolio/pbmc.JPG";
import LoginPortfolio from "./LoginPortfolio";

export default function PortfolioData() {
  const [showLogin, setShowLogin] = useState(false);
  const [selectedProject, setSelectedProject] = useState("");

  const projects = [
    {
      title: "Amazon Replica",
      webUrl: "http://portfolio.infograins.com/portfolio/amazon-replica/",
      image: amazonReplica,
    },
    {
      title: "E-businessmart",
      webUrl: "http://portfolio.infograins.com/portfolio/ebusinessmart/",
      image: bussinessMart,
    },
    {
      title: "PBMC",
      webUrl: "http://portfolio.infograins.com/portfolio/pbmc",
      image: pbmc,
    },
    {
      title: "Uno Solace",
      webUrl: "http://portfolio.infograins.com/portfolio/uno",
      image: solaceUno,
    },
    {
      title: "Start Naukri",
      webUrl: "http://portfolio.infograins.com/portfolio/startnaukri/",
      image: startNukari,
    },
    {
      title: "Marhaba Admin",
      webUrl: "http://portfolio.infograins.com/portfolio/marhaba/admin/",
      image: marhaba,
    },
    {
      title: "Oxyzn Admin",
      webUrl:
        "http://portfolio.infograins.com/portfolio/oxyzn/wp-login.php?redirect_to=http%3A%2F%2Fportfolio.infograins.com%2Fportfolio%2Foxyzn%2F&bp-auth=1&action=bpnoaccess",
      image: oxyzn,
    },
  ];

  const handleLogin = (projectTitle) => {
    setSelectedProject(projectTitle);
    setShowLogin(true);
  };

  const closePopup = () => setShowLogin(false);

  return (
    <div className="portfolio-container">
      {projects.map((project, index) => (
        <div key={index} className="project-card">
          <div className="card-left">
            <img
              src={project.image}
              alt={project.title}
              className="project-img"
            />
          </div>
          <div className="card-right">
            <h2>{project.title}</h2>
            <p>
              <strong>Web URL:</strong>{" "}
              <a href={project.webUrl} target="_blank" rel="noreferrer">
                {project.webUrl}
              </a>
            </p>
            <button className="login-btn" onClick={handleLogin}>
              Get Login Details
            </button>
          </div>
        </div>
      ))}
      {showLogin && (
        <LoginPortfolio
          selectedProject={selectedProject}
          onClose={closePopup}
          projects={projects}
        />
      )}
    </div>
  );
}
